/** Integer minor unit of THB. 1 baht = 100 satang. Never a float. */
export type Satang = number & { readonly __brand: 'satang' };

export const isSatang = (value: unknown): value is Satang =>
  typeof value === 'number' && Number.isInteger(value);

export function assertSatang(
  value: number,
  field = 'amount',
): asserts value is Satang {
  if (!Number.isInteger(value)) {
    throw new Error(`${field}: satang must be an integer, got ${value}`);
  }
}

/** Display only. Converts satang → "123.45" baht string. */
export const formatBaht = (satang: number): string => {
  const sign = satang < 0 ? '-' : '';
  const abs = Math.abs(Math.trunc(satang));
  const whole = Math.floor(abs / 100);
  const frac = abs % 100;
  return `${sign}${whole}.${frac.toString().padStart(2, '0')}`;
};

/** Input parse only. Baht text → integer satang, half-up. */
export const parseBahtToSatang = (text: string): Satang => {
  const trimmed = text.trim();
  if (trimmed === '') return 0 as Satang;
  const baht = Number(trimmed);
  if (!Number.isFinite(baht)) return 0 as Satang;
  const scaled = baht * 100;
  return (
    scaled >= 0 ? Math.floor(scaled + 0.5) : Math.ceil(scaled - 0.5)
  ) as Satang;
};
